<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2024.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2024-09-03                                                         -
  ----------------------------------------------------------------------------->

<template>
  <b-container style="margin-top: 70px">
    <b-row>
      <b-col>
        <h1 class="mb-5 mt-3"><strong>Request a Quote</strong></h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <p class="mb-5">Please complete this form to have a copy of your quote request emailed to you and to our direct sale partner. Our sales representative will contact you shortly on available discounts and shipping options.</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form class="mb-5">
          <b-container>
            <b-row>
              <b-col>
                <b-form-group
                    label="First Name"
                    label-for="first_name">
                  <b-form-input size="sm"
                      id="first_name"
                      v-model="quote_request_form.first_name"
                      type="text"
                      required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                    label="Last Name"
                    label-for="last_name">
                  <b-form-input size="sm"
                      id="last_name"
                      v-model="quote_request_form.last_name"
                      type="text"
                      required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                    label="Email"
                    label-for="email">
                  <b-form-input size="sm"
                      id="email"
                      v-model="quote_request_form.email"
                      type="email"
                      required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                    label="Re-enter Email"
                    label-for="email_confirmation">
                  <b-form-input size="sm"
                      id="email_confirmation"
                      v-model="quote_request_form.email_confirmation"
                      type="email"
                      required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                    label="Phone"
                    label-for="phone">
                  <b-form-input size="sm"
                      id="phone"
                      v-model="quote_request_form.phone"
                      type="phone"
                      required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group id="group_quantity_estimate" label="Quantity Estimate:" label-for="quantity">
                  <b-form-select size="sm"
                      id="quantity"
                      v-model="quote_request_form.quantity"
                      :options="quantity_options"
                      required
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                    label="Company"
                    label-for="company_name">
                  <b-form-input size="sm"
                      id="first_name"
                      v-model="quote_request_form.company_name"
                      type="text"
                      required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group id="industry_form_group" label="Company Sector or Industry:" label-for="industry">
                  <b-form-select size="sm"
                      id="industry"
                      v-model="quote_request_form.industry"
                      :options="industry_options"
                      required
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                    label="Job Title"
                    label-for="job_title">
                  <b-form-input size="sm"
                      id="job_title"
                      v-model="quote_request_form.job_title"
                      type="text"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                    label="Address 1"
                    label-for="address_1">
                  <b-form-input size="sm"
                      id="address_1"
                      v-model="quote_request_form.address_1"
                      type="text"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                    label="Address 2"
                    label-for="address_2">
                  <b-form-input size="sm"
                      id="address_2"
                      v-model="quote_request_form.address_2"
                      type="text"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                    label="City/Town"
                    label-for="city">
                  <b-form-input size="sm"
                      id="address_2"
                      v-model="quote_request_form.city"
                      type="text"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                    label="State"
                    label-for="state">
                  <b-form-input size="sm"
                      id="state"
                      v-model="quote_request_form.state"
                      type="text"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                    label="Zip"
                    label-for="zip">
                  <b-form-input size="sm"
                      id="zip"
                      v-model="quote_request_form.zip"
                      type="text"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                    label="Country"
                    label-for="country">
                  <b-form-input size="sm"
                      id="country"
                      v-model="quote_request_form.country"
                      type="text"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                    label="Comments"
                    label-for="comments">
                  <b-form-textarea
                      id="comments"
                      v-model="quote_request_form.comments"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-button type="submit" size="lg" variant="dark">Submit</b-button>
              </b-col>
            </b-row>
          </b-container>
        </b-form>
      </b-col>
      <b-col>
        <b-container>
          <b-row>
            <b-col>
              <h2 class="m-3">Quote Summary</h2>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-table-lite small
                            striped
                            stacked="lg"
                            class="mb-0"
                            :items="sorted_rows"
                            :fields="fields">
                <template v-slot:cell(part_number)="data">
                  {{ data.item.code }}
                </template>
                <template v-slot:cell(part_description)="data">
                  {{ data.item.name }}<br>
                </template>
                <template v-slot:cell(msrp_price)="data">
                  {{ formatCurrency(data.item.msrp_price) }}
                </template>
              </b-table-lite>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button type="submit" size="lg" variant="dark" class="mt-3">Submit</b-button>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Yega1CardForm from "@/components/yega/yega1/yega1-card-form.vue";
import Yega1DataSourceItem from "@/components/yega/yega1/yega1-data-source-item.vue";
import useCurrencyFormatter from "@/compositions/use-currency-formatter";
import YesNo from "@/enums/yes-no";

export default {
  name: "quote-request-info",
  components: {
    Yega1CardForm,
    Yega1DataSourceItem
  },
  props:{
  },
  setup(){
    const { formatCurrency } = useCurrencyFormatter();
    return {
      formatCurrency
    };
  },
  computed:{
    quote_part_id(){
      return this.CurrentUserStore.user.current_quote_part_id;
    },
    sorted_rows(){
      return this.rows.sort((row1,row2)=>{
        if(row1.product.index < row2.product.index){
          return -1;
        }else if(row1.product.index > row2.product.index){
          return 1;
        }else{
          return 0;
        }
      });
    },
    quote_version_id(){
      return this.CurrentUserStore.user.current_quote_version_id
    }
  },
  data(){
    return {
      CurrentUserStore:this.$store.state.CurrentUserStore,
      quotePart:null,
      rows: [],
      fields: [
        {key: 'part_number', label: 'Part Number'},
        {key: 'part_description', label: 'Description '},
        {key: 'msrp_price', label: 'MSRP '},
        {key: 'actions', label: ''}
      ],
      quote_request_form:{
        quantity: null,
        industry: null
      },
      quantity_options:[{ text: 'Please select quantity', value: null }, '1-10 Laptops', '11-50 Laptops', '51-100 Laptops', '101-1000 Laptops','1000+ Laptops'],
      industry_options:[{ text: 'Please select company sector', value: null }, 'Government', 'Education', 'HealthCare', 'Enterprise','Small to Medium Business'],
    };
  },
  created(){
    this.$store.dispatch('CurrentUserStore/show',{show_current_quote_id:'YES'})
        .then((item)=>{
          this.loadQuotePart();
        })
        .catch((error)=>{alert(error.response ? error.response.data : error);});
  },
  methods:{
    loadQuotePart(){
      this.$store.dispatch('QuotePartsStore/show',this.quote_part_id)
          .then(this.handleItemLoaded)
          .catch((error)=>{alert(error.response ? error.response.data : error);});
    },
    handleItemLoaded(item){
      this.quotePart = item;
      this.arrangeRows(item);
    },
    arrangeRows(item){
      this.rows = [];
      item.quote_products.forEach((quote_product)=>{
        if (this.isAccessory(quote_product)) {
          quote_product.quote_product_details.forEach((quote_product_detail) => {
            this.rows.push({
              product: quote_product,
              product_detail: quote_product_detail,
              attribute_store:quote_product_detail.attribute_store,
              code: quote_product_detail.code,
              name: quote_product_detail.name,
              msrp_price: this.productPrice(quote_product_detail, 'esup'),
              partner_price: this.productPrice(quote_product_detail, 'partner-price')
            });
          });
        } else {
          this.rows.push({
            product: quote_product,
            attribute_store:quote_product.attribute_store,
            code: quote_product.attribute_store['standard_quote_lookedup_part_number'],
            name: quote_product.attribute_store['standard_quote_product_description'],
            msrp_price: this.productPrice(quote_product, 'product_esup'),
            partner_price: this.productPrice(quote_product, 'product_partner_price')
          });
        }
      })
    },
    isAccessory(quote_product){
      return quote_product.attribute_store['standard_quote_is_accessory'] === YesNo.YES;
    },
    productPrice(quote_object,price_name){
      if(!quote_object.calculated_price_transformation_values){
        debugger;
      }
      let price_object = quote_object
          .calculated_price_transformation_values
          .find((price_object)=>{
            return price_object.name === price_name;
          });
      if(price_object){
        return price_object.value;
      }
    },
  }
}
</script>

<style scoped>

</style>
